export default __webpack_public_path__ + "static/media/sms-pack-green.d18022bf.svg";